// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"regEditDropdown__gradient-bg5__IDBsj","popOverMenu":"regEditDropdown__popOverMenu__q48Uh"};